// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const showMoreText = (data) => {
  return `${
    data.isShowingMore
      ? `${__('Show less', 'vn')}`
      : `${__('Show more sectors', 'vn')}`
  }`
}

export default showMoreText
